var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardMessageMarkasreadNormalIcon = function SvgNewcsDashboardMessageMarkasreadNormalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_message_markasread_normal_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M91 546h14v14H91z",
    "data-name": "\\u77E9\\u5F62 527"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_message_markasread_normal_icon_svg__a)",
    transform: "translate(-91 -546)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "m91.909 557.432-.012-8.863a2.59 2.59 0 0 1 2.6-2.57h6.992a2.587 2.587 0 0 1 2.6 2.569l.012 4.061a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6l-.012-4.063a1.387 1.387 0 0 0-1.4-1.371h-6.991a1.386 1.386 0 0 0-1.4 1.37l.012 8.863a1.386 1.386 0 0 0 1.4 1.37l2.67-.014a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6l-2.673.014a2.59 2.59 0 0 1-2.598-2.566m7.927 2.092-2.261-2.261a.6.6 0 0 1 0-.849.6.6 0 0 1 .848 0l1.837 1.837 3.676-3.676a.6.6 0 0 1 .848 0 .6.6 0 0 1 0 .849l-4.1 4.1a.6.6 0 0 1-.425.176.6.6 0 0 1-.422-.176Zm-4.332-5.424a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6Zm0-3a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h5a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6Z",
    "data-name": "\\u8054\\u5408 78"
  }))));
};
export default SvgNewcsDashboardMessageMarkasreadNormalIcon;